import React from 'react';
import { Icon } from '@iconify/react';
import AuthenticatedImage from '../../components/auth/private-image';

function ProfileSection({ profile, onOpenModal }) {
  return (
    <div id="general" className="mb-4 pb-3">
      <h4 className="d-flex align-items-center mb-2 mt-3">
        <Icon className="iconify fs-24px me-2 text-body text-opacity-75 my-n1" icon="solar:user-bold-duotone" />
        General (一般設定)
      </h4>
      <p>基本的なプロフィール情報とアカウント設定を管理します。</p>

      <div className="card">
        <div className="list-group list-group-flush fw-bold">

          {/* プロフィール画像セクション（モーダル起動版） */}
          <div className="list-group-item d-flex align-items-center p-3">
            <div className="flex-fill d-flex align-items-center">
              <AuthenticatedImage
                filename={profile.profile_image}
                className="rounded-circle me-3"
                style={{ width: '60px', height: '60px' }}
              />
              <div>
                <div>Profile Image (プロフィール画像)</div>
                <div className="text-body text-opacity-60 fw-normal">PNG, JPG, GIFが使用可能です。</div>
              </div>
            </div>
            <div className="w-100px text-end">
              <a href="#modalEdit" data-bs-toggle="modal" onClick={() => onOpenModal('image')} className="btn btn-secondary btn-sm w-100px">
                Change
              </a>
            </div>
          </div>

          <div className="list-group-item d-flex align-items-center">
            <div className="flex-fill">
              <div>Name (お名前)</div>
              <div className="text-body text-opacity-60 fw-normal">{profile.last_name} {profile.first_name}</div>
            </div>
            <div className="w-100px text-end">
              <a href="#modalEdit" data-bs-toggle="modal" onClick={() => onOpenModal('name')} className="btn btn-secondary btn-sm w-100px">Edit</a>
            </div>
          </div>

          <div className="list-group-item d-flex align-items-center">
            <div className="flex-fill">
              <div>Nickname (ニックネーム)</div>
              <div className="text-body text-opacity-60 fw-normal">{profile.nickname ? `@${profile.nickname}` : '未設定'}</div>
            </div>
            <div className="w-100px text-end">
              <a href="#modalEdit" data-bs-toggle="modal" onClick={() => onOpenModal('name')} className="btn btn-secondary btn-sm w-100px">Edit</a>
            </div>
          </div>

          <div className="list-group-item d-flex align-items-center">
            <div className="flex-fill">
              <div>Email address (メールアドレス)</div>
              <div className="text-body text-opacity-60 fw-normal">{profile.email}</div>
            </div>
            <div className="w-100px text-end">
              <a href="#modalEdit" data-bs-toggle="modal" onClick={() => onOpenModal('email')} className="btn btn-secondary btn-sm w-100px">Edit</a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ProfileSection;